<template>
  <p class="asc-surface--supportText">{{ text }}</p>
</template>

<script>
export default {
  name: 'AscSurfaceSupportText',

  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-surface--supportText {
  font-size: 14px !important;
  letter-spacing: normal !important;
  line-height: 18px;
  color: $gray-1000;
  font-weight: normal;
}
</style>
